export default __webpack_public_path__ + "static/media/TVS KING GS+ 3.a674916e.webp";